// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"699ed066","453":"53af25fd","455":"8b213277","977":"e9b2a4b5"}[chunkId] + ".chunk.js";
};